const ENPHASE_INSTALLER = 'enphase_installer'
const CUSTOMER_SUPPORT = 'customer_support'

export { ENPHASE_INSTALLER, CUSTOMER_SUPPORT }
